import Grid from '@mui/material/Grid';
import "./style.css";
import React from 'react';
import {useState, useEffect, useRef} from 'react';
import {useNavigate} from "react-router-dom";
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { purple } from '@mui/material/colors';
import Divider from '@mui/material/Divider';
import axios from 'axios';
import { Search } from "@mui/icons-material";
import { IconButton} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import InputAdornment from '@mui/material/InputAdornment';
import UploadDomisiliKokas from './UploadDomisiliKokas'
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import {readEmpty} from "./apiDomisiliKokas.js";

export default function LihatDomisiliKokas({currPreview}){
  const [skip, setSkip] = useState(0);
  const [isEnd,setIsEnd] = useState("loading..");
  const navigate = useNavigate();
  const [query,setQuery] = useState("");
  const [previewVisibility, setPreviewVisibility] = useState(false);
  const [loadVisibility, setLoadVisibility] = useState(false);
  const [tanggalSurat, setTanggalSurat]= useState(new Date())
  const [tanggalMulaiDomisili,setTanggalMulaiDomisili] = useState(new Date(currPreview.TanggalMulai))
  const [durasiDomisili, setDurasiDomisili] = useState(1);
  const handleDateChange = (date) => {
    setTanggalSurat(date);
    const piDate = date.getDate();
    const longMonth = date.toLocaleString('default', { month: 'long' });
    const piYear = date.getFullYear();
    console.log(piDate + " " + longMonth + " " + piYear);
}
const handleMulaiDomisiliDateChange = (date) => {
  setTanggalMulaiDomisili(date);
  const piDate = date.getDate();
  const longMonth = date.toLocaleString('default', { month: 'long' });
  const piYear = date.getFullYear();
  console.log(piDate + " " + longMonth + " " + piYear);
}
const handleClosePreview = (event) =>{
  setPreviewVisibility(false)
}
const [posts, setPosts] = useState([])
useEffect(() => {
  fetchPosts();
  console.log(posts)
}, [skip,query]);
const fetchPosts = async () => {
  const id = currPreview._id
  try{
      const { data, error } = await readEmpty(skip,query,id);
      if(error){
          console.log(error.message);
          return;
      }
      console.log(data)
      if(data?.length === 0){
          setIsEnd("Selesai...");
          return;
      }
      
      //success
      setPosts([...posts, ...data])
  }catch(error){
      console.log(error.message);
  } 
  
}

const newFetchPosts = async (event) => {
  setPosts([])
  setIsEnd("Loading...");
      console.log("empty")
      const id = currPreview._id
      try{
          const { data, error } = await readEmpty(skip,event.target.value,id);
          if(error){
              console.log(error.message);
              return;
          }

          if(data?.length === 0){
              setIsEnd("Selesai...");
              return;
          }
          
          //success
          setPosts([...posts, ...data])
      }catch(error){
          console.log(error.message);
      } 
}
const handleScroll = (e) => {
  const { offsetHeight, scrollTop, scrollHeight } = e.target;

  if(offsetHeight + scrollTop >= scrollHeight){
      setSkip(posts?.length);
  }
}
const downloadDokumenPengajuan = (event) => {
  //Download Dok KTP NPWP Klien
  axios.get(`${process.env.REACT_APP_BACKEND_URL}/KlienProfile?thisClient=${currPreview.KlienID}`, {
  }).then((response) => {
    const ktpKey = response.data.data[0].ktpKey?? "";
    const npwpKey = response.data.data[0].npwpKey?? "";
    console.log(response.data.data[0].npwpKey?? "NPWP Tidak ada Upload")
    console.log(response.data.data[0].ktpKey?? "KTP Tidak ada Upload" )
    
    //KTP Key
    if(ktpKey){
      if (Array.isArray(ktpKey)) {
        ktpKey.forEach(filename => {
          console.log(filename)
            axios.get(`${process.env.REACT_APP_BACKEND_URL}/getFile?filename=${filename}`, {
                responseType: 'blob' // Tell axios to get the response as a blob
            })
            .then((response) => {
              const contentType = response.headers['content-type'];
              console.log(response);
              console.log(response.headers)
              console.log(contentType)
              if (['image/png', 'image/jpeg', 'image/gif', 'application/pdf', 'image/webp', 'image/jpg'].includes(contentType)) {
                // If it's a PNG, JPEG, GIF or PDF, open it in a new browser tab
                const blob = new Blob([response.data], { type: contentType });
                const url = URL.createObjectURL(blob);
                window.open(url);
            } else {
                // For other file types, download the file
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(new Blob([response.data]));
                link.setAttribute('download', 'file'); // Modify the filename and extension as needed
                document.body.appendChild(link);
                link.click();
            }
            })
            .catch((error) => {
                console.log('Error fetching the file:', error);
            });
        });
    } else {
      axios.get(`${process.env.REACT_APP_BACKEND_URL}/getFile?filename=${ktpKey}`, {
        responseType: 'blob' // Tell axios to get the response as a blob
    })
    .then((response) => {
      const contentType = response.headers['content-type'];
      console.log(response);
      console.log(response.headers)
      console.log(contentType)
      if (['image/png', 'image/jpeg', 'image/gif', 'application/pdf'].includes(contentType)) {
        // If it's a PNG, JPEG, GIF or PDF, open it in a new browser tab
        const blob = new Blob([response.data], { type: contentType });
        const url = URL.createObjectURL(blob);
        window.open(url);
    } else {
        // For other file types, download the file
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(new Blob([response.data]));
        link.setAttribute('download', 'file'); // Modify the filename and extension as needed
        document.body.appendChild(link);
        link.click();
    }
    })
    .catch((error) => {
        console.log('Error fetching the file:', error);
    });
    }
    }

          //KTP Key End
  
          //NPWP Key
    if(npwpKey){
      if (Array.isArray(npwpKey)) {
        npwpKey.forEach(filename => {
          console.log(filename)
            axios.get(`${process.env.REACT_APP_BACKEND_URL}/getFile?filename=${filename}`, {
                responseType: 'blob' // Tell axios to get the response as a blob
            })
            .then((response) => {
              const contentType = response.headers['content-type'];
              console.log(response);
              console.log(response.headers)
              console.log(contentType)
              if (['image/png', 'image/jpeg', 'image/gif', 'application/pdf', 'image/webp', 'image/jpg'].includes(contentType)) {
                // If it's a PNG, JPEG, GIF or PDF, open it in a new browser tab
                const blob = new Blob([response.data], { type: contentType });
                const url = URL.createObjectURL(blob);
                window.open(url);
            } else {
                // For other file types, download the file
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(new Blob([response.data]));
                link.setAttribute('download', 'file'); // Modify the filename and extension as needed
                document.body.appendChild(link);
                link.click();
            }
            })
            .catch((error) => {
                console.log('Error fetching the file:', error);
            });
        });
    } else {
      axios.get(`${process.env.REACT_APP_BACKEND_URL}/getFile?filename=${npwpKey}`, {
        responseType: 'blob' // Tell axios to get the response as a blob
    })
    .then((response) => {
      const contentType = response.headers['content-type'];
      console.log(response);
      console.log(response.headers)
      console.log(contentType)
      if (['image/png', 'image/jpeg', 'image/gif', 'application/pdf'].includes(contentType)) {
        // If it's a PNG, JPEG, GIF or PDF, open it in a new browser tab
        const blob = new Blob([response.data], { type: contentType });
        const url = URL.createObjectURL(blob);
        window.open(url);
    } else {
        // For other file types, download the file
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(new Blob([response.data]));
        link.setAttribute('download', 'file'); // Modify the filename and extension as needed
        document.body.appendChild(link);
        link.click();
    }
    })
    .catch((error) => {
        console.log('Error fetching the file:', error);
    });
    }
    }

          //NPWP Key End
  })
  .catch((error) => {
    console.error('There was an error!', error);
  });
  //End Download Doc KTP NPWP Klien

  //Start Surat Permohonan
  try {
    axios.post(`${process.env.REACT_APP_BACKEND_URL}/suratPermohonanDomisiliVOfromDB`,{
        id: currPreview._id, tanggalMulaiDomisili, durasiDomisili, tanggalSurat
    },{
        responseType: "blob" 
    }).then(resp => {
        console.log(resp)
            const blob = new Blob([resp.data], { type: 'application/pdf' })
        // saveAs(blob);
        var fileURLNew = URL.createObjectURL(blob);
        console.log(fileURLNew)
        window.open(fileURLNew, '_blank');
    })
  } catch (error) {
    console.error(error);
  } finally {
  }

  //End Surat Permohonan

  //Start Kontrak untuk Domisili
    try {
            axios.post(`${process.env.REACT_APP_BACKEND_URL}/renderKontrakDomisiliVOfromDB`,{
                id: currPreview._id, tanggalMulaiDomisili, durasiDomisili
            },{
                responseType: "blob" 
            }).then(resp => {
                console.log(resp)
                    const blob = new Blob([resp.data], { type: 'application/pdf' })
                // saveAs(blob);
                var fileURLNew = URL.createObjectURL(blob);
                console.log(fileURLNew)
                window.open(fileURLNew, '_blank');
            })
          } catch (error) {
            console.error(error);
          } finally {
          }
  //End Kontrak untuk Domisili
}
const [uploadDomisiliOpen,setUploadDomisiliOpen] = useState(false);
const uploadDomisili = () => {
  setUploadDomisiliOpen(true)
}
const closesetUploadDomisiliOpen = () => {
  setUploadDomisiliOpen(false)
}
const [fileURL, setFileURL]= useState();
const previewPDF = async (post) => {
  console.log("diatas")
  setLoadVisibility(true)
  const id = post._id
  console.log(post)
         //NPWP Key
         if(post){
          if (Array.isArray(post[0])) {
            post.forEach(filename => {
              console.log(filename)
                axios.get(`${process.env.REACT_APP_BACKEND_URL}/getFile?filename=${filename.signatureKey}`, {
                    responseType: 'blob' // Tell axios to get the response as a blob
                })
                .then((response) => {
                  const contentType = response.headers['content-type'];
                  console.log(response);
                  console.log(response.headers)
                  console.log(contentType)
                  if (['image/png', 'image/jpeg', 'image/gif', 'application/pdf', 'image/webp', 'image/jpg'].includes(contentType)) {
                    // If it's a PNG, JPEG, GIF or PDF, open it in a new browser tab
                    const blob = new Blob([response.data], { type: contentType });
                    var fileURLNew = URL.createObjectURL(blob);

                    setPreviewVisibility(true)
                    setFileURL(fileURLNew)   
                    console.log("here3")
                  } else {
                    // For other file types, download the file
                    const blob = new Blob([response.data], { type: contentType });
                    var fileURLNew = URL.createObjectURL(blob);

                    setPreviewVisibility(true)
                    setFileURL(fileURLNew)   
                }
                })
                .catch((error) => {
                    console.log('Error fetching the file:', error);
                });
            });
        } else {
          axios.get(`${process.env.REACT_APP_BACKEND_URL}/getFile?filename=${post.signatureKey}`, {
            responseType: 'blob' // Tell axios to get the response as a blob
        })
        .then((response) => {
          const contentType = response.headers['content-type'];
          console.log(response);
          console.log(response.headers)
          console.log(contentType)
          if (['image/png', 'image/jpeg', 'image/gif', 'application/pdf'].includes(contentType)) {
            // If it's a PNG, JPEG, GIF or PDF, open it in a new browser tab
            const blob = new Blob([response.data], { type: contentType });
                    var fileURLNew = URL.createObjectURL(blob);

                    setPreviewVisibility(true)
                    setFileURL(fileURLNew)   

        } else {
            // For other file types, download the file
            const blob = new Blob([response.data], { type: contentType });
            var fileURLNew = URL.createObjectURL(blob);

            setPreviewVisibility(true)
            setFileURL(fileURLNew)   
        }
        })
        .catch((error) => {
            console.log('Error fetching the file:', error);
        });
        }
        }
    
              //NPWP Key End

  setLoadVisibility(false)
  console.log("2")

}
    return <Grid sx={{m:2}}>
    <Dialog
                    open={previewVisibility}
                    onClose={handleClosePreview}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "1250px",  // Set your width here
                        },
                    },}}
                                >
                    <DialogTitle id="alert-dialog-title">
                        <Button onClick={handleClosePreview} autoFocus>
                            <CloseIcon></CloseIcon>
                        </Button>
                    </DialogTitle>
                    <DialogContent>
                    <iframe src={fileURL} width="100%" height="500" style={{zoom:"150%"}}/>
                    </DialogContent>
                </Dialog>
    <Dialog open={uploadDomisiliOpen} onClose={closesetUploadDomisiliOpen}>
      <UploadDomisiliKokas currPreview={currPreview}></UploadDomisiliKokas>
      </Dialog>
    <Typography>List Domisili Perusahaan {currPreview.CompanyName}</Typography>        
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                                <TableContainer sx={{ maxHeight: 500, minHeight: 440 }} className="min-h-screen h-screen overflow-scroll" onScroll={handleScroll}>
                                    <Table stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell style={{ width: 200 }}>
                                                    Kode Domisili
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        {posts?.map((postArray, index) => (
                                          postArray.map((post, postIndex) => (
                                              <TableBody key={`${index}-${postIndex}`}>
                                                  <TableRow hover>
                                                      <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer'}}>
                                                          <p>{post.signatureKey}</p>
                                                      </TableCell>
                                                  </TableRow>
                                              </TableBody>
                                          ))
                                      ))}
                                        {isEnd}
                                    </Table>
                                </TableContainer>
                            </Paper>
    <Grid xs={12} sx={{mt:2, mb:2}}>
        <Button variant="contained" color="success" onClick={uploadDomisili}>Upload Domisili</Button>
    </Grid>

    </Grid>
}